var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{on:{"click":function($event){return _vm.$emit('acao')}}},[_c('icone-simples-redondo-com-label',{attrs:{"label-botao":"EP","texto":"Estorno parcial","cor-background":"grey"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }